import React from 'react';
import PropTypes from 'prop-types';
const moment = require('moment-timezone');
const semver = require('semver');
const keyBy = require('lodash/keyBy');

const Strings = require('../../../../../app/shared/Strings');
const StringUtil = require('../../../../../app/shared/StringUtil');
import Tooltip from '../../common/Tooltip';
import { PublishMessageTooltip } from '../../activity/ActivitySavesTable';

const propTypes = {
	versions: PropTypes.arrayOf(PropTypes.shape({
		version: PropTypes.string.isRequired,
		published_by_first_name: PropTypes.string,
		published_by_last_name: PropTypes.string,
		published_on: PropTypes.string.isRequired,
        unpublished: PropTypes.bool.isRequired,
        unpublished_on: PropTypes.string,
        unpublished_by_first_name: PropTypes.string,
        unpublished_by_last_name: PropTypes.string,
        publish_message: PropTypes.string,
        completed_count: PropTypes.number.isRequired,
	})),
	activeMinVersion: PropTypes.string,
	activeMaxVersion: PropTypes.string,
	timezone: PropTypes.string,
	dateFormat: PropTypes.string,
};

const defaultProps = {
	versions: [],
	activeMinVersion: null,
	activeMaxVersion: null,
	timezone: moment.tz.guess(),
	dateFormat: 'YY-MM-DD HH:mm zz',
};

export default function QLAVersionLog(props) {
	if (props.versions.length === 0) return null;

	const keyedVersions = keyBy(props.versions, 'version');
	const sortedVersions = semver.rsort(props.versions.map(v => v.version));
	const verInRange = (version) => {
		if (!props.activeMinVersion || !props.activeMaxVersion) return true;

		return (
			semver.gte(version, props.activeMinVersion)
			&& semver.lte(version, props.activeMaxVersion)
		);
	}
	let lastInRange;
	return (
		<table className="qlaVersionTable">
			<thead>
				<tr>
					<th>{Strings['en'].activity.qla.act_version.THEAD_VERSION}</th>
					<th>{Strings['en'].activity.qla.act_version.THEAD_PUB_USER}</th>
					<th>{Strings['en'].activity.qla.act_version.THEAD_PUB_DATE}</th>
					<th className="qlaVersionTableCell--alignCenter">{Strings['en'].activity.qla.act_version.THEAD_PUB_NUM_COMPLETED}</th>
					<th className="qlaVersionTableCell--alignCenter">{Strings['en'].activity.qla.act_version.THEAD_PUB_MSG}</th>
				</tr>
			</thead>
			<tbody>
				{sortedVersions.map((version, index) => {
					const versionRecord = keyedVersions[version];
					const isInRange = verInRange(versionRecord.version);
					let rowClassName = '';
					if (isInRange) {
						if (index > 0 && !lastInRange) {
							rowClassName = 'enabledBoundaryTop'
						}

					}
					else {
						if (index > 0 && lastInRange) {
							rowClassName = 'enabledBoundaryTop disabled'
						}
						else {
							rowClassName = 'disabled';
						}

					}

					lastInRange = isInRange;
					return (
						<tr className={rowClassName} key={versionRecord.version}>
							<td>{versionRecord.version}</td>
							<td>{versionRecord.published_by_first_name} {versionRecord.published_by_last_name}</td>
							<td>{moment.tz(versionRecord.published_on, props.timezone).format(props.dateFormat)}</td>
							<td className="qlaVersionTableCell--alignCenter">
								{StringUtil.numberToLocaleString(versionRecord.completed_count)}
							</td>
							<td className="qlaVersionTableCell--alignCenter">
								<PublishMessageTooltip id={versionRecord.id} saveData={versionRecord} timezone={props.timezone} />
							</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
}

QLAVersionLog.propTypes = propTypes;
QLAVersionLog.defaultProps = defaultProps;